// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

let ReactRelay = require("react-relay");
let RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");
let DevicePixelRatio = require("../v5/common/DevicePixelRatio.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");

function makeRefetchVariables() {
  
}

let Types = {
  makeRefetchVariables: makeRefetchVariables
};

let variablesConverter = {};

function convertVariables(v) {
  return RescriptRelay.convertObj(v, variablesConverter, undefined, undefined);
}

let wrapResponseConverter = {"__root":{"":{"f":""}}};

function convertWrapResponse(v) {
  return RescriptRelay.convertObj(v, wrapResponseConverter, undefined, null);
}

let responseConverter = {"__root":{"":{"f":""}}};

function convertResponse(v) {
  return RescriptRelay.convertObj(v, responseConverter, undefined, undefined);
}

let Internal = {
  variablesConverter: variablesConverter,
  variablesConverterMap: undefined,
  convertVariables: convertVariables,
  wrapResponseConverter: wrapResponseConverter,
  wrapResponseConverterMap: undefined,
  convertWrapResponse: convertWrapResponse,
  responseConverter: responseConverter,
  responseConverterMap: undefined,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapResponse,
  convertRawResponse: convertResponse
};

let Utils = {};

let providedVariablesDefinition = {
  __relay_internal__pv__DevicePixelRatio: {
    providedVariable: DevicePixelRatio.get,
    get: DevicePixelRatio.get
  }
};

function makeNode(providedVariablesDefinition) {
  return ((function(){
var v0 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 100
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "nodeId",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v5 = {
  "kind": "Variable",
  "name": "ratio",
  "variableName": "__relay_internal__pv__DevicePixelRatio"
},
v6 = {
  "alias": null,
  "args": null,
  "concreteType": "Agent",
  "kind": "LinkedField",
  "name": "agent",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    (v4/*: any*/),
    (v3/*: any*/),
    {
      "alias": "agentProfilePhoto",
      "args": null,
      "concreteType": "ProfilePhoto",
      "kind": "LinkedField",
      "name": "profilePhoto",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": [
            (v5/*: any*/),
            {
              "kind": "Literal",
              "name": "width",
              "value": 60
            }
          ],
          "kind": "ScalarField",
          "name": "url",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v7 = [
  (v6/*: any*/),
  (v3/*: any*/)
],
v8 = [
  {
    "kind": "InlineFragment",
    "selections": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v4/*: any*/)
    ],
    "type": "ClientV5",
    "abstractKey": "__isClientV5"
  },
  (v3/*: any*/)
],
v9 = {
  "alias": null,
  "args": null,
  "concreteType": "RentalNeedV5",
  "kind": "LinkedField",
  "name": "source",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Renter",
      "kind": "LinkedField",
      "name": "client",
      "plural": false,
      "selections": (v8/*: any*/),
      "storageKey": null
    },
    (v3/*: any*/)
  ],
  "storageKey": null
},
v10 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "MatchForRentalNeedV5",
    "kind": "LinkedField",
    "name": "node",
    "plural": false,
    "selections": [
      (v9/*: any*/),
      (v3/*: any*/)
    ],
    "storageKey": null
  }
],
v11 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "MatchForRentalNeedV5",
    "kind": "LinkedField",
    "name": "node",
    "plural": false,
    "selections": [
      (v2/*: any*/),
      (v9/*: any*/),
      (v3/*: any*/)
    ],
    "storageKey": null
  }
],
v12 = {
  "alias": null,
  "args": null,
  "concreteType": "Seller",
  "kind": "LinkedField",
  "name": "client",
  "plural": false,
  "selections": (v8/*: any*/),
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "locationDisplay",
  "storageKey": null
},
v14 = {
  "kind": "InlineFragment",
  "selections": [
    (v13/*: any*/)
  ],
  "type": "PropertyLocationWithHiddenAddress",
  "abstractKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "address",
  "storageKey": null
},
v16 = {
  "kind": "InlineFragment",
  "selections": [
    (v1/*: any*/),
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "propertyLocation",
      "plural": false,
      "selections": [
        (v1/*: any*/),
        (v14/*: any*/),
        {
          "kind": "InlineFragment",
          "selections": [
            (v15/*: any*/)
          ],
          "type": "PropertyLocationWithVisibleAddress",
          "abstractKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "PropertyV5",
  "abstractKey": "__isPropertyV5"
},
v17 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "MatchForForSalePropertyV5",
    "kind": "LinkedField",
    "name": "node",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ForSalePropertyV5",
        "kind": "LinkedField",
        "name": "source",
        "plural": false,
        "selections": [
          (v12/*: any*/),
          (v16/*: any*/),
          (v3/*: any*/)
        ],
        "storageKey": null
      },
      (v3/*: any*/)
    ],
    "storageKey": null
  }
],
v18 = {
  "alias": null,
  "args": null,
  "concreteType": "ForSalePropertyV5",
  "kind": "LinkedField",
  "name": "source",
  "plural": false,
  "selections": [
    (v16/*: any*/),
    (v12/*: any*/),
    (v3/*: any*/)
  ],
  "storageKey": null
},
v19 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "MatchForForSalePropertyV5",
    "kind": "LinkedField",
    "name": "node",
    "plural": false,
    "selections": [
      (v2/*: any*/),
      (v18/*: any*/),
      (v3/*: any*/)
    ],
    "storageKey": null
  }
],
v20 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "MatchForForSalePropertyV5",
    "kind": "LinkedField",
    "name": "node",
    "plural": false,
    "selections": [
      (v18/*: any*/),
      (v3/*: any*/)
    ],
    "storageKey": null
  }
],
v21 = {
  "alias": null,
  "args": null,
  "concreteType": "Landlord",
  "kind": "LinkedField",
  "name": "client",
  "plural": false,
  "selections": (v8/*: any*/),
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "concreteType": "RentalPropertyV5",
  "kind": "LinkedField",
  "name": "source",
  "plural": false,
  "selections": [
    (v16/*: any*/),
    (v21/*: any*/),
    (v3/*: any*/)
  ],
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "concreteType": "BuyerNeedV5",
  "kind": "LinkedField",
  "name": "source",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Buyer",
      "kind": "LinkedField",
      "name": "client",
      "plural": false,
      "selections": (v8/*: any*/),
      "storageKey": null
    },
    (v3/*: any*/)
  ],
  "storageKey": null
},
v24 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "MatchForBuyerNeedV5",
    "kind": "LinkedField",
    "name": "node",
    "plural": false,
    "selections": [
      (v23/*: any*/),
      (v3/*: any*/)
    ],
    "storageKey": null
  }
],
v25 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "MatchForBuyerNeedV5",
    "kind": "LinkedField",
    "name": "node",
    "plural": false,
    "selections": [
      (v2/*: any*/),
      (v23/*: any*/),
      (v3/*: any*/)
    ],
    "storageKey": null
  }
],
v26 = {
  "kind": "InlineFragment",
  "selections": [
    (v3/*: any*/)
  ],
  "type": "Node",
  "abstractKey": "__isNode"
},
v27 = [
  (v2/*: any*/),
  (v4/*: any*/),
  (v3/*: any*/)
],
v28 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Literal",
        "name": "format",
        "value": "FULL"
      }
    ],
    "kind": "ScalarField",
    "name": "formatted",
    "storageKey": "formatted(format:\"FULL\")"
  }
],
v29 = {
  "alias": null,
  "args": null,
  "concreteType": "PriceRange",
  "kind": "LinkedField",
  "name": "priceRange",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Price",
      "kind": "LinkedField",
      "name": "maxPrice",
      "plural": false,
      "selections": (v28/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Price",
      "kind": "LinkedField",
      "name": "minPrice",
      "plural": false,
      "selections": (v28/*: any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
},
v30 = [
  (v2/*: any*/),
  (v3/*: any*/)
],
v31 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "propertyLocation",
  "plural": false,
  "selections": [
    (v1/*: any*/),
    (v14/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        (v13/*: any*/),
        (v15/*: any*/)
      ],
      "type": "PropertyLocationWithVisibleAddress",
      "abstractKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "AlertsDropdownQuery",
    "selections": [
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "AlertsDropdown_query"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__DevicePixelRatio"
      }
    ],
    "kind": "Operation",
    "name": "AlertsDropdownQuery",
    "selections": [
      {
        "alias": null,
        "args": (v0/*: any*/),
        "concreteType": "QueryAlertsForCurrentUserConnection",
        "kind": "LinkedField",
        "name": "alertsForCurrentUser",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "QueryAlertsForCurrentUserConnectionEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "grouping",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "status",
                    "storageKey": null
                  },
                  {
                    "kind": "TypeDiscriminator",
                    "abstractKey": "__isAlertV5"
                  },
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "timestamp",
                    "storageKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "agentMatchLog",
                        "plural": false,
                        "selections": [
                          (v1/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "databaseId",
                            "storageKey": null
                          },
                          {
                            "kind": "TypeDiscriminator",
                            "abstractKey": "__isAgentMatchLogV5"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "RentalPropertyV5",
                                "kind": "LinkedField",
                                "name": "source",
                                "plural": false,
                                "selections": (v7/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "event",
                                "plural": false,
                                "selections": [
                                  (v1/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "RentalPropertyCreatedAMLEventMatchesConnection",
                                        "kind": "LinkedField",
                                        "name": "matches",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "RentalPropertyCreatedAMLEventMatchesConnectionEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": (v10/*: any*/),
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "type": "RentalPropertyCreatedAMLEvent",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "RentalPropertyEditedAMLEventExistingMatchesConnection",
                                        "kind": "LinkedField",
                                        "name": "existingMatches",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "RentalPropertyEditedAMLEventExistingMatchesConnectionEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": (v11/*: any*/),
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "RentalPropertyEditedAMLEventNewMatchesConnection",
                                        "kind": "LinkedField",
                                        "name": "newMatches",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "RentalPropertyEditedAMLEventNewMatchesConnectionEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": (v10/*: any*/),
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "type": "RentalPropertyEditedAMLEvent",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "RentalPropertyRebroadcastedAMLEventExistingMatchesConnection",
                                        "kind": "LinkedField",
                                        "name": "existingMatches",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "RentalPropertyRebroadcastedAMLEventExistingMatchesConnectionEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": (v11/*: any*/),
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "RentalPropertyRebroadcastedAMLEventNewMatchesConnection",
                                        "kind": "LinkedField",
                                        "name": "newMatches",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "RentalPropertyRebroadcastedAMLEventNewMatchesConnectionEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": (v10/*: any*/),
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "type": "RentalPropertyRebroadcastedAMLEvent",
                                    "abstractKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "RentalPropertyAgentMatchLogV5",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "BuyerNeedV5",
                                "kind": "LinkedField",
                                "name": "source",
                                "plural": false,
                                "selections": (v7/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "event",
                                "plural": false,
                                "selections": [
                                  (v1/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "BroadcastBuyerNeedCreatedAMLEventMatchesConnection",
                                        "kind": "LinkedField",
                                        "name": "matches",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "BroadcastBuyerNeedCreatedAMLEventMatchesConnectionEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": (v17/*: any*/),
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "type": "BroadcastBuyerNeedCreatedAMLEvent",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "BuyerNeedEditedAMLEventExistingMatchesConnection",
                                        "kind": "LinkedField",
                                        "name": "existingMatches",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "BuyerNeedEditedAMLEventExistingMatchesConnectionEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": (v19/*: any*/),
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "BuyerNeedEditedAMLEventNewMatchesConnection",
                                        "kind": "LinkedField",
                                        "name": "newMatches",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "BuyerNeedEditedAMLEventNewMatchesConnectionEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": (v20/*: any*/),
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "type": "BuyerNeedEditedAMLEvent",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "QuietBuyerNeedBroadcastedAMLEventExistingMatchesConnection",
                                        "kind": "LinkedField",
                                        "name": "existingMatches",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "QuietBuyerNeedBroadcastedAMLEventExistingMatchesConnectionEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": (v19/*: any*/),
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "QuietBuyerNeedBroadcastedAMLEventNewMatchesConnection",
                                        "kind": "LinkedField",
                                        "name": "newMatches",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "QuietBuyerNeedBroadcastedAMLEventNewMatchesConnectionEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": (v20/*: any*/),
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "type": "QuietBuyerNeedBroadcastedAMLEvent",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "QuietBuyerNeedCreatedAMLEventMatchesConnection",
                                        "kind": "LinkedField",
                                        "name": "matches",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "QuietBuyerNeedCreatedAMLEventMatchesConnectionEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": (v17/*: any*/),
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "type": "QuietBuyerNeedCreatedAMLEvent",
                                    "abstractKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "BuyerNeedAgentMatchLogV5",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "RentalNeedV5",
                                "kind": "LinkedField",
                                "name": "source",
                                "plural": false,
                                "selections": (v7/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "event",
                                "plural": false,
                                "selections": [
                                  (v1/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "RentalNeedCreatedAMLEventMatchesConnection",
                                        "kind": "LinkedField",
                                        "name": "matches",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "RentalNeedCreatedAMLEventMatchesConnectionEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "MatchForRentalPropertyV5",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "RentalPropertyV5",
                                                    "kind": "LinkedField",
                                                    "name": "source",
                                                    "plural": false,
                                                    "selections": [
                                                      (v21/*: any*/),
                                                      (v16/*: any*/),
                                                      (v3/*: any*/)
                                                    ],
                                                    "storageKey": null
                                                  },
                                                  (v3/*: any*/)
                                                ],
                                                "storageKey": null
                                              }
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "type": "RentalNeedCreatedAMLEvent",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "RentalNeedEditedAMLEventExistingMatchesConnection",
                                        "kind": "LinkedField",
                                        "name": "existingMatches",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "RentalNeedEditedAMLEventExistingMatchesConnectionEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "MatchForRentalPropertyV5",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                  (v2/*: any*/),
                                                  (v22/*: any*/),
                                                  (v3/*: any*/)
                                                ],
                                                "storageKey": null
                                              }
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "RentalNeedEditedAMLEventNewMatchesConnection",
                                        "kind": "LinkedField",
                                        "name": "newMatches",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "RentalNeedEditedAMLEventNewMatchesConnectionEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "MatchForRentalPropertyV5",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                  (v22/*: any*/),
                                                  (v3/*: any*/)
                                                ],
                                                "storageKey": null
                                              }
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "type": "RentalNeedEditedAMLEvent",
                                    "abstractKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "RentalNeedAgentMatchLogV5",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ForSalePropertyV5",
                                "kind": "LinkedField",
                                "name": "source",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "agentV2",
                                    "plural": false,
                                    "selections": [
                                      (v1/*: any*/),
                                      {
                                        "kind": "TypeDiscriminator",
                                        "abstractKey": "__isForSalePropertyAgent"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v6/*: any*/)
                                        ],
                                        "type": "VisibleForSalePropertyAgent",
                                        "abstractKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  (v3/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "event",
                                "plural": false,
                                "selections": [
                                  (v1/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "BroadcastPropertyCreatedAMLEventMatchesConnection",
                                        "kind": "LinkedField",
                                        "name": "matches",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "BroadcastPropertyCreatedAMLEventMatchesConnectionEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": (v24/*: any*/),
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "type": "BroadcastPropertyCreatedAMLEvent",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "QuietPropertyCreatedAMLEventMatchesConnection",
                                        "kind": "LinkedField",
                                        "name": "matches",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "QuietPropertyCreatedAMLEventMatchesConnectionEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": (v24/*: any*/),
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "type": "QuietPropertyCreatedAMLEvent",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "ForSalePropertyEditedAMLEventExistingMatchesConnection",
                                        "kind": "LinkedField",
                                        "name": "existingMatches",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "ForSalePropertyEditedAMLEventExistingMatchesConnectionEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": (v25/*: any*/),
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "ForSalePropertyEditedAMLEventNewMatchesConnection",
                                        "kind": "LinkedField",
                                        "name": "newMatches",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "ForSalePropertyEditedAMLEventNewMatchesConnectionEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": (v24/*: any*/),
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "type": "ForSalePropertyEditedAMLEvent",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "ForSalePropertyRebroadcastedAMLEventExistingMatchesConnection",
                                        "kind": "LinkedField",
                                        "name": "existingMatches",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "ForSalePropertyRebroadcastedAMLEventExistingMatchesConnectionEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": (v25/*: any*/),
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "ForSalePropertyRebroadcastedAMLEventNewMatchesConnection",
                                        "kind": "LinkedField",
                                        "name": "newMatches",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "ForSalePropertyRebroadcastedAMLEventNewMatchesConnectionEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": (v24/*: any*/),
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "type": "ForSalePropertyRebroadcastedAMLEvent",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "QuietPropertyBroadcastedAMLEventExistingMatchesConnection",
                                        "kind": "LinkedField",
                                        "name": "existingMatches",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "QuietPropertyBroadcastedAMLEventExistingMatchesConnectionEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": (v25/*: any*/),
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "QuietPropertyBroadcastedAMLEventNewMatchesConnection",
                                        "kind": "LinkedField",
                                        "name": "newMatches",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "QuietPropertyBroadcastedAMLEventNewMatchesConnectionEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": (v24/*: any*/),
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "type": "QuietPropertyBroadcastedAMLEvent",
                                    "abstractKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "ForSalePropertyAgentMatchLogV5",
                            "abstractKey": null
                          },
                          (v26/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "AgentMatchLogAlert",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ConversationMessageV5",
                        "kind": "LinkedField",
                        "name": "message",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "from",
                            "plural": false,
                            "selections": [
                              (v1/*: any*/),
                              {
                                "kind": "TypeDiscriminator",
                                "abstractKey": "__isConversationParticipantV5"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v4/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ProfilePhoto",
                                    "kind": "LinkedField",
                                    "name": "profilePhoto",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": [
                                          (v5/*: any*/),
                                          {
                                            "kind": "Literal",
                                            "name": "width",
                                            "value": 40
                                          }
                                        ],
                                        "kind": "ScalarField",
                                        "name": "url",
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  (v2/*: any*/)
                                ],
                                "type": "Agent",
                                "abstractKey": null
                              },
                              (v26/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v3/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "status",
                            "plural": false,
                            "selections": [
                              (v1/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ConversationV5",
                        "kind": "LinkedField",
                        "name": "conversation",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          {
                            "alias": null,
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "first",
                                "value": 1
                              }
                            ],
                            "concreteType": "ConversationMessagesConnection",
                            "kind": "LinkedField",
                            "name": "messages",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ConversationMessagesEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ConversationMessageV5",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": null,
                                        "kind": "LinkedField",
                                        "name": "from",
                                        "plural": false,
                                        "selections": [
                                          (v1/*: any*/),
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              (v2/*: any*/)
                                            ],
                                            "type": "Agent",
                                            "abstractKey": null
                                          },
                                          (v26/*: any*/)
                                        ],
                                        "storageKey": null
                                      },
                                      (v3/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": "messages(first:1)"
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "conversationContext",
                            "plural": false,
                            "selections": [
                              (v1/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "context",
                                    "plural": false,
                                    "selections": [
                                      (v1/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "matchingType",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "Buyer",
                                            "kind": "LinkedField",
                                            "name": "client",
                                            "plural": false,
                                            "selections": (v27/*: any*/),
                                            "storageKey": null
                                          },
                                          (v29/*: any*/)
                                        ],
                                        "type": "BuyerNeedV5",
                                        "abstractKey": null
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "Renter",
                                            "kind": "LinkedField",
                                            "name": "client",
                                            "plural": false,
                                            "selections": (v27/*: any*/),
                                            "storageKey": null
                                          },
                                          (v29/*: any*/)
                                        ],
                                        "type": "RentalNeedV5",
                                        "abstractKey": null
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "alias": "propertyClient",
                                            "args": null,
                                            "concreteType": "Landlord",
                                            "kind": "LinkedField",
                                            "name": "client",
                                            "plural": false,
                                            "selections": (v30/*: any*/),
                                            "storageKey": null
                                          },
                                          (v31/*: any*/)
                                        ],
                                        "type": "RentalPropertyV5",
                                        "abstractKey": null
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "alias": "propertyClient",
                                            "args": null,
                                            "concreteType": "Seller",
                                            "kind": "LinkedField",
                                            "name": "client",
                                            "plural": false,
                                            "selections": (v30/*: any*/),
                                            "storageKey": null
                                          },
                                          (v31/*: any*/)
                                        ],
                                        "type": "ForSalePropertyV5",
                                        "abstractKey": null
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v2/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "subject",
                                            "storageKey": null
                                          }
                                        ],
                                        "type": "MessageBroadcast",
                                        "abstractKey": null
                                      },
                                      (v26/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "type": "AvailableConversationContext",
                                "abstractKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v3/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "ConversationMessageAlert",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": "alertsForCurrentUser(first:100)"
      },
      {
        "alias": null,
        "args": (v0/*: any*/),
        "filters": null,
        "handle": "connection",
        "key": "AlertsDropdownQuery_alertsForCurrentUser",
        "kind": "LinkedHandle",
        "name": "alertsForCurrentUser"
      }
    ]
  },
  "params": {
    "cacheID": "883ad5193d5441030f8c504fc66c0a19",
    "id": null,
    "metadata": {},
    "name": "AlertsDropdownQuery",
    "operationKind": "query",
    "text": "query AlertsDropdownQuery(\n  $__relay_internal__pv__DevicePixelRatio: Float!\n) {\n  ...AlertsDropdown_query\n}\n\nfragment AgentMatchLogTextsBuyerNeed_aml on BuyerNeedAgentMatchLogV5 {\n  databaseId\n  source {\n    agent {\n      ...NotificationsAndAlertsUtilsAgent_agent\n      nodeId\n    }\n    nodeId\n  }\n  event {\n    __typename\n    ... on BroadcastBuyerNeedCreatedAMLEvent {\n      matches {\n        edges {\n          node {\n            source {\n              client {\n                ...NotificationsAndAlertsUtilsClientLabel_client\n                nodeId\n              }\n              ...NotificationsAndAlertsUtilsPropertyLocationLabel_property\n              nodeId\n            }\n            nodeId\n          }\n        }\n      }\n    }\n    ... on BuyerNeedEditedAMLEvent {\n      existingMatches {\n        edges {\n          node {\n            id\n            source {\n              ...NotificationsAndAlertsUtilsPropertyLocationLabel_property\n              client {\n                ...NotificationsAndAlertsUtilsClientLabel_client\n                nodeId\n              }\n              nodeId\n            }\n            nodeId\n          }\n        }\n      }\n      newMatches {\n        edges {\n          node {\n            source {\n              ...NotificationsAndAlertsUtilsPropertyLocationLabel_property\n              client {\n                ...NotificationsAndAlertsUtilsClientLabel_client\n                nodeId\n              }\n              nodeId\n            }\n            nodeId\n          }\n        }\n      }\n    }\n    ... on QuietBuyerNeedBroadcastedAMLEvent {\n      existingMatches {\n        edges {\n          node {\n            id\n            source {\n              ...NotificationsAndAlertsUtilsPropertyLocationLabel_property\n              client {\n                ...NotificationsAndAlertsUtilsClientLabel_client\n                nodeId\n              }\n              nodeId\n            }\n            nodeId\n          }\n        }\n      }\n      newMatches {\n        edges {\n          node {\n            source {\n              ...NotificationsAndAlertsUtilsPropertyLocationLabel_property\n              client {\n                ...NotificationsAndAlertsUtilsClientLabel_client\n                nodeId\n              }\n              nodeId\n            }\n            nodeId\n          }\n        }\n      }\n    }\n    ... on QuietBuyerNeedCreatedAMLEvent {\n      matches {\n        edges {\n          node {\n            source {\n              client {\n                ...NotificationsAndAlertsUtilsClientLabel_client\n                nodeId\n              }\n              ...NotificationsAndAlertsUtilsPropertyLocationLabel_property\n              nodeId\n            }\n            nodeId\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment AgentMatchLogTextsForSaleProperty_aml on ForSalePropertyAgentMatchLogV5 {\n  databaseId\n  source {\n    agentV2 {\n      __typename\n      ...NotificationsAndAlertsUtilsForSale_agent\n      ...NotificationsAndAlertsUtilsForSale_agentId\n    }\n    nodeId\n  }\n  event {\n    __typename\n    ... on BroadcastPropertyCreatedAMLEvent {\n      matches {\n        edges {\n          node {\n            source {\n              client {\n                ...NotificationsAndAlertsUtilsClientLabel_client\n                nodeId\n              }\n              nodeId\n            }\n            nodeId\n          }\n        }\n      }\n    }\n    ... on QuietPropertyCreatedAMLEvent {\n      matches {\n        edges {\n          node {\n            source {\n              client {\n                ...NotificationsAndAlertsUtilsClientLabel_client\n                nodeId\n              }\n              nodeId\n            }\n            nodeId\n          }\n        }\n      }\n    }\n    ... on ForSalePropertyEditedAMLEvent {\n      existingMatches {\n        edges {\n          node {\n            id\n            source {\n              client {\n                ...NotificationsAndAlertsUtilsClientLabel_client\n                nodeId\n              }\n              nodeId\n            }\n            nodeId\n          }\n        }\n      }\n      newMatches {\n        edges {\n          node {\n            source {\n              client {\n                ...NotificationsAndAlertsUtilsClientLabel_client\n                nodeId\n              }\n              nodeId\n            }\n            nodeId\n          }\n        }\n      }\n    }\n    ... on ForSalePropertyRebroadcastedAMLEvent {\n      existingMatches {\n        edges {\n          node {\n            id\n            source {\n              client {\n                ...NotificationsAndAlertsUtilsClientLabel_client\n                nodeId\n              }\n              nodeId\n            }\n            nodeId\n          }\n        }\n      }\n      newMatches {\n        edges {\n          node {\n            source {\n              client {\n                ...NotificationsAndAlertsUtilsClientLabel_client\n                nodeId\n              }\n              nodeId\n            }\n            nodeId\n          }\n        }\n      }\n    }\n    ... on QuietPropertyBroadcastedAMLEvent {\n      existingMatches {\n        edges {\n          node {\n            id\n            source {\n              client {\n                ...NotificationsAndAlertsUtilsClientLabel_client\n                nodeId\n              }\n              nodeId\n            }\n            nodeId\n          }\n        }\n      }\n      newMatches {\n        edges {\n          node {\n            source {\n              client {\n                ...NotificationsAndAlertsUtilsClientLabel_client\n                nodeId\n              }\n              nodeId\n            }\n            nodeId\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment AgentMatchLogTextsRentalNeed_aml on RentalNeedAgentMatchLogV5 {\n  databaseId\n  source {\n    agent {\n      ...NotificationsAndAlertsUtilsAgent_agent\n      nodeId\n    }\n    nodeId\n  }\n  event {\n    __typename\n    ... on RentalNeedCreatedAMLEvent {\n      matches {\n        edges {\n          node {\n            source {\n              client {\n                ...NotificationsAndAlertsUtilsClientLabel_client\n                nodeId\n              }\n              ...NotificationsAndAlertsUtilsPropertyLocationLabel_property\n              nodeId\n            }\n            nodeId\n          }\n        }\n      }\n    }\n    ... on RentalNeedEditedAMLEvent {\n      existingMatches {\n        edges {\n          node {\n            id\n            source {\n              ...NotificationsAndAlertsUtilsPropertyLocationLabel_property\n              client {\n                ...NotificationsAndAlertsUtilsClientLabel_client\n                nodeId\n              }\n              nodeId\n            }\n            nodeId\n          }\n        }\n      }\n      newMatches {\n        edges {\n          node {\n            source {\n              ...NotificationsAndAlertsUtilsPropertyLocationLabel_property\n              client {\n                ...NotificationsAndAlertsUtilsClientLabel_client\n                nodeId\n              }\n              nodeId\n            }\n            nodeId\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment AgentMatchLogTextsRentalProperty_aml on RentalPropertyAgentMatchLogV5 {\n  databaseId\n  source {\n    agent {\n      ...NotificationsAndAlertsUtilsAgent_agent\n      ...NotificationsAndAlertsUtilsAgent_agentId\n      nodeId\n    }\n    nodeId\n  }\n  event {\n    __typename\n    ... on RentalPropertyCreatedAMLEvent {\n      matches {\n        edges {\n          node {\n            source {\n              client {\n                ...NotificationsAndAlertsUtilsClientLabel_client\n                nodeId\n              }\n              nodeId\n            }\n            nodeId\n          }\n        }\n      }\n    }\n    ... on RentalPropertyEditedAMLEvent {\n      existingMatches {\n        edges {\n          node {\n            id\n            source {\n              client {\n                ...NotificationsAndAlertsUtilsClientLabel_client\n                nodeId\n              }\n              nodeId\n            }\n            nodeId\n          }\n        }\n      }\n      newMatches {\n        edges {\n          node {\n            source {\n              client {\n                ...NotificationsAndAlertsUtilsClientLabel_client\n                nodeId\n              }\n              nodeId\n            }\n            nodeId\n          }\n        }\n      }\n    }\n    ... on RentalPropertyRebroadcastedAMLEvent {\n      existingMatches {\n        edges {\n          node {\n            id\n            source {\n              client {\n                ...NotificationsAndAlertsUtilsClientLabel_client\n                nodeId\n              }\n              nodeId\n            }\n            nodeId\n          }\n        }\n      }\n      newMatches {\n        edges {\n          node {\n            source {\n              client {\n                ...NotificationsAndAlertsUtilsClientLabel_client\n                nodeId\n              }\n              nodeId\n            }\n            nodeId\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment AgentProfilePhoto_agent on Agent {\n  displayName\n  agentProfilePhoto: profilePhoto {\n    url(width: 60, ratio: $__relay_internal__pv__DevicePixelRatio)\n  }\n}\n\nfragment AlertsDropdownAlertsSection_alerts on AlertV5 {\n  __isAlertV5: __typename\n  __typename\n  id\n  grouping\n  nodeId\n  ...AlertsDropdownItem_alert\n}\n\nfragment AlertsDropdownItem_alert on AlertV5 {\n  __isAlertV5: __typename\n  __typename\n  id\n  status\n  timestamp\n  ... on AgentMatchLogAlert {\n    id\n    agentMatchLog {\n      __typename\n      databaseId\n      __isAgentMatchLogV5: __typename\n      ... on RentalPropertyAgentMatchLogV5 {\n        ...NotificationWidgetTextsRentalProperty_aml\n        source {\n          agent {\n            ...AgentProfilePhoto_agent\n            nodeId\n          }\n          nodeId\n        }\n      }\n      ... on BuyerNeedAgentMatchLogV5 {\n        ...NotificationWidgetTextsBuyerNeed_aml\n        source {\n          agent {\n            ...AgentProfilePhoto_agent\n            nodeId\n          }\n          nodeId\n        }\n      }\n      ... on RentalNeedAgentMatchLogV5 {\n        ...NotificationWidgetTextsRentalNeed_aml\n        source {\n          agent {\n            ...AgentProfilePhoto_agent\n            nodeId\n          }\n          nodeId\n        }\n      }\n      ... on ForSalePropertyAgentMatchLogV5 {\n        ...NotificationWidgetTextsForSaleProperty_aml\n        source {\n          agentV2 {\n            __typename\n            ... on AnonymousForSalePropertyAgent {\n              __typename\n            }\n            ... on VisibleForSalePropertyAgent {\n              agent {\n                ...AgentProfilePhoto_agent\n                nodeId\n              }\n            }\n          }\n          nodeId\n        }\n      }\n      ... on Node {\n        __isNode: __typename\n        __typename\n        nodeId\n      }\n    }\n  }\n  ... on ConversationMessageAlert {\n    id\n    message {\n      from {\n        __typename\n        ...ConversationParticipantProfilePhoto_participant\n        __isConversationParticipantV5: __typename\n        ... on Agent {\n          displayName\n          id\n        }\n        ... on Node {\n          __isNode: __typename\n          __typename\n          nodeId\n        }\n      }\n      nodeId\n      status {\n        __typename\n        ... on IncomingMessageStatus {\n          __typename\n        }\n        ... on OutgoingMessageStatus {\n          __typename\n        }\n      }\n    }\n    conversation {\n      id\n      messages(first: 1) {\n        edges {\n          node {\n            from {\n              __typename\n              ... on Agent {\n                id\n              }\n              ... on Node {\n                __isNode: __typename\n                __typename\n                nodeId\n              }\n            }\n            nodeId\n          }\n        }\n      }\n      conversationContext {\n        __typename\n        ... on AvailableConversationContext {\n          context {\n            __typename\n            ... on BuyerNeedV5 {\n              matchingType\n              client {\n                id\n                displayName\n                nodeId\n              }\n              priceRange {\n                maxPrice {\n                  formatted(format: FULL)\n                }\n                minPrice {\n                  formatted(format: FULL)\n                }\n              }\n            }\n            ... on RentalNeedV5 {\n              client {\n                id\n                displayName\n                nodeId\n              }\n              priceRange {\n                maxPrice {\n                  formatted(format: FULL)\n                }\n                minPrice {\n                  formatted(format: FULL)\n                }\n              }\n            }\n            ... on RentalPropertyV5 {\n              propertyClient: client {\n                id\n                nodeId\n              }\n              propertyLocation {\n                __typename\n                ... on PropertyLocationWithHiddenAddress {\n                  locationDisplay\n                }\n                ... on PropertyLocationWithVisibleAddress {\n                  locationDisplay\n                  address\n                }\n              }\n            }\n            ... on ForSalePropertyV5 {\n              propertyClient: client {\n                id\n                nodeId\n              }\n              propertyLocation {\n                __typename\n                ... on PropertyLocationWithHiddenAddress {\n                  locationDisplay\n                }\n                ... on PropertyLocationWithVisibleAddress {\n                  locationDisplay\n                  address\n                }\n              }\n            }\n            ... on MessageBroadcast {\n              id\n              subject\n            }\n            ... on Node {\n              __isNode: __typename\n              __typename\n              nodeId\n            }\n          }\n        }\n      }\n      nodeId\n    }\n  }\n}\n\nfragment AlertsDropdown_query on Query {\n  alertsForCurrentUser(first: 100) {\n    totalCount\n    edges {\n      node {\n        __typename\n        id\n        grouping\n        status\n        ...AlertsDropdownAlertsSection_alerts\n        nodeId\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment ConversationParticipantProfilePhoto_participant on ConversationParticipantV5 {\n  __isConversationParticipantV5: __typename\n  __typename\n  ... on Agent {\n    displayName\n    profilePhoto {\n      url(width: 40, ratio: $__relay_internal__pv__DevicePixelRatio)\n    }\n  }\n  ... on AnonymousConversationParticipant {\n    __typename\n  }\n}\n\nfragment NotificationWidgetTextsBuyerNeed_aml on BuyerNeedAgentMatchLogV5 {\n  ...AgentMatchLogTextsBuyerNeed_aml\n}\n\nfragment NotificationWidgetTextsForSaleProperty_aml on ForSalePropertyAgentMatchLogV5 {\n  ...AgentMatchLogTextsForSaleProperty_aml\n}\n\nfragment NotificationWidgetTextsRentalNeed_aml on RentalNeedAgentMatchLogV5 {\n  ...AgentMatchLogTextsRentalNeed_aml\n}\n\nfragment NotificationWidgetTextsRentalProperty_aml on RentalPropertyAgentMatchLogV5 {\n  ...AgentMatchLogTextsRentalProperty_aml\n}\n\nfragment NotificationsAndAlertsUtilsAgent_agent on Agent {\n  id\n  displayName\n}\n\nfragment NotificationsAndAlertsUtilsAgent_agentId on Agent {\n  id\n}\n\nfragment NotificationsAndAlertsUtilsClientLabel_client on ClientV5 {\n  __isClientV5: __typename\n  __typename\n  id\n  displayName\n}\n\nfragment NotificationsAndAlertsUtilsForSale_agent on ForSalePropertyAgent {\n  __isForSalePropertyAgent: __typename\n  __typename\n  ... on VisibleForSalePropertyAgent {\n    agent {\n      ...NotificationsAndAlertsUtilsAgent_agent\n      nodeId\n    }\n  }\n  ... on AnonymousForSalePropertyAgent {\n    __typename\n  }\n}\n\nfragment NotificationsAndAlertsUtilsForSale_agentId on ForSalePropertyAgent {\n  __isForSalePropertyAgent: __typename\n  __typename\n  ... on VisibleForSalePropertyAgent {\n    agent {\n      id\n      nodeId\n    }\n  }\n}\n\nfragment NotificationsAndAlertsUtilsPropertyLocationLabel_property on PropertyV5 {\n  __isPropertyV5: __typename\n  __typename\n  id\n  propertyLocation {\n    __typename\n    ... on PropertyLocationWithHiddenAddress {\n      locationDisplay\n    }\n    ... on PropertyLocationWithVisibleAddress {\n      address\n    }\n  }\n}\n",
    "providedVariables": providedVariablesDefinition
  }
};
})());
}

let node = makeNode(providedVariablesDefinition);

function load(environment, variables, fetchPolicy, fetchKey, networkCacheConfig) {
  return ReactRelay.loadQuery(environment, node, convertVariables(variables), {
    fetchKey: fetchKey,
    fetchPolicy: fetchPolicy,
    networkCacheConfig: networkCacheConfig
  });
}

function queryRefToObservable(token) {
  return Primitive_option.fromNullable(token.source);
}

function queryRefToPromise(token) {
  return new Promise((resolve, _reject) => {
    let o = queryRefToObservable(token);
    if (o !== undefined) {
      Primitive_option.valFromOption(o).subscribe({
        complete: () => resolve({
          TAG: "Ok",
          _0: undefined
        })
      });
      return;
    } else {
      return resolve({
        TAG: "Error",
        _0: undefined
      });
    }
  });
}

exports.Types = Types;
exports.Internal = Internal;
exports.Utils = Utils;
exports.providedVariablesDefinition = providedVariablesDefinition;
exports.node = node;
exports.load = load;
exports.queryRefToObservable = queryRefToObservable;
exports.queryRefToPromise = queryRefToPromise;
/* node Not a pure module */
